// extracted by mini-css-extract-plugin
module.exports = {"other-products-section":"OtherProducts_other-products-section__1dRnY","other-products-grid":"OtherProducts_other-products-grid__1kcTD"};